export default __webpack_public_path__ + "static/media/pc-fases.6a3cd3c9.png";